import { differenceInDays } from "date-fns"

/**
 * Returns the number of whole days between now and the provided date.
 * @param {String} date - Date string.
 * @returns {Number} Number of full days between `now` and `date`.
 */
export const getDaysLeft = (date: string): number => {
  const now = new Date()
  const lastUpdateDate = new Date(date)
  const days = differenceInDays(now, lastUpdateDate)

  return days
}
